import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step13 from './Step13-redux';

export default compose(
  withRouter,
  withNextStep
)(Step13);
